// Create: src/hooks/useNormalizedMenuItems.ts
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useNormalizedMenuItems = () => {
  const rawMenuItems = useSelector((state: any) => state.menu.menuItems);
  
  const normalizedItems = useMemo(() => {
    if (!rawMenuItems || rawMenuItems.length === 0) return [];
    
    // If it's already a flat array (normal case)
    if (Array.isArray(rawMenuItems) && rawMenuItems[0] && !rawMenuItems[0].items) {
      return rawMenuItems;
    }
    
    // If it's wrapped in category structure (problematic case)
    if (Array.isArray(rawMenuItems) && rawMenuItems[0] && rawMenuItems[0].items) {
      console.warn('Menu items were in category structure, normalizing...');
      return rawMenuItems[0].items;
    }
    
    return [];
  }, [rawMenuItems]);
  
  return normalizedItems;
};